var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-box"},[_c('div',{staticClass:"title-zh"},[_vm._v(_vm._s(_vm.title.titleZh))]),_c('div',{staticClass:"title-en"},[_vm._v(_vm._s(_vm.title.titleEn))])])}
var staticRenderFns = []

export { render, staticRenderFns }